import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

import { Button, SectionTitle } from '@/ui/index';
import { ArrowRight } from '@/icons/index';

import styles from './GeneralServices.module.scss';

const Item = ({
  item: { text, icon, button_text: buttonText, button_slug: buttonSlug },
}) => {
  return (
    <div
      className={styles['service-item']}
      itemScope
      itemType='http://schema.org/ListItem'
    >
      <div className={styles['service-item__content']}>
        <div className={styles['service-item__content__iconContainer']}>
          <Image
            src={icon}
            className={styles['service-item__content__iconContainer__icon']}
            alt={text}
            title={text}
            loading='lazy'
            width={40}
            height={40}
          />
        </div>
        <div className={styles['service-item__title']}>{text}</div>
      </div>
      <Button
        className={styles['service-item__button']}
        variant='red'
        Component={buttonSlug ? 'router' : 'button'}
        href={buttonSlug}
      >
        <span>{buttonText}</span>
        <ArrowRight width={24} />
      </Button>
    </div>
  );
};

const GeneralServices = ({ services }) => {
  const mainBox = services?.sections?.[0] || {};

  const renderItems = (item, index) => {
    return <Item item={item} key={index} />;
  };

  return (
    <div
      className={classNames('wrapper', 'section')}
      itemScope
      itemType='http://schema.org/Service'
    >
      <SectionTitle
        icon={services?.icon}
        className={styles['general-service__title-block']}
        titleModify='title--large'
      >
        {services?.text}
      </SectionTitle>
      <div className={styles['general-service__inner']}>
        <div className={styles['service-item-own']}>
          <div className={styles['service-item-own__caption']}>
            <div className={styles['service-item-own__content']}>
              <div className={styles['service-item-own__iconContainer']}>
                <Image
                  src={mainBox?.icon}
                  className={styles['service-item-own__iconContainer__icon']}
                  alt={mainBox?.text}
                  title={mainBox?.text}
                  loading='lazy'
                  width={56}
                  height={56}
                />
              </div>
              {mainBox?.text && (
                <SectionTitle
                  titleModify={classNames(
                    styles['service-item-own__title'],
                    'title--large',
                  )}
                >
                  {mainBox.text}
                </SectionTitle>
              )}
            </div>
            <Button
              className={styles['service-item-own__button']}
              variant='red'
              href={mainBox?.button_slug}
              Component='router'
            >
              {mainBox?.button_text}
              <ArrowRight width={24} />
            </Button>
          </div>
        </div>
        {services?.sections?.slice(1)?.map(renderItems)}
      </div>
    </div>
  );
};

export default GeneralServices;
